import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-point-right': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M428.8 137.6c45.1 0 83.2 38.1 83.2 83.2 0 45.6-37.8 83.2-83.2 83.2h-35.6c-1.4 6.4-5 16.3-7.9 22.1 2.5 22-3.5 45-16 62.8-1.1 52.5-37.4 91.1-99.9 91.1h-21.3c-60.1 0-98.5-40-127.2-40h-2.7c-5.7 5-13.5 8-22.1 8h-64c-17.7 0-32-12.9-32-28.8v-230.4c0-15.9 14.3-28.8 32-28.8h64c8.6 0 16.4 3 22.1 8h2.7c7 0 14.9-6.2 30.2-23.7l0.1-0.1 0.1-0.1c8.9-9.9 18.1-20.8 25.9-33.3 18.7-30.2 30.4-78.8 75.7-78.8 56.9 0 92 35.3 92 83.2v0.1c0 6.2-1 16.2-2.2 22.3h86.2zM428.8 256c19 0 35.2-16.2 35.2-35.2 0-18.7-16.8-35.2-35.2-35.2h-158.4c0-17.3 26.4-35.2 26.4-70.4 0-26.4-20.6-35.2-44-35.2-8.8 0-20.4 32.7-34.9 56.1-9.1 14.6-19.5 27.2-30.8 39.9-16.1 18.4-33.8 36.6-59.1 39.6v176.8c42.8 3.8 74.5 39.7 120 39.7h21.3c40.5 0 57.1-22.2 50.6-61.3 14.6-8 24.2-34 12.9-53.6 19.4-18.2 17.8-46.4 5-61h91zM88 384c0-13.3-10.7-24-24-24s-24 10.7-24 24 10.7 24 24 24 24-10.7 24-24z'
      }
    ]
  }
})
